import React from 'react';
import Icon from '../../../components/AppIcon';
import { useAuth } from 'context/AuthContext';

const QuickStats = () => {

  const { courseOverview } = useAuth();

  const statItems = [
    {
      label: 'Chapters Completed',
      value: courseOverview?.completedCourses ,
      total: 4,
      icon: 'BookCheck',
      color: 'text-success',
      bgColor: 'bg-success/10'
    },
    {
      label: 'Quiz Average',
      value: `${Math.round(courseOverview?.quizAvg)} % `,
      icon: 'Award',
      color: 'text-secondary',
      bgColor: 'bg-secondary/10'
    },
    // {
    //   label: 'Study Streak',
    //   value: `${ stats.studyStreak } days`,
    //   icon: 'Flame',
    //   color: 'text-warning',
    //   bgColor: 'bg-warning/10'
    // },
    // {
    //   label: 'Time Spent',
    //   value: stats.totalTimeSpent,
    //   icon: 'Clock',
    //   color: 'text-primary',
    //   bgColor: 'bg-primary/10'
    // }
  ];

  return (
    <div className="grid grid-cols-2 gap-4 mt-6 mb-6 lg:grid-cols-4">
      {statItems.map((stat, index) => (
        <div
          key={index}
          className="p-4 transition-shadow duration-200 border rounded-lg bg-surface border-border hover:shadow-elevation-1"
        >
          <div className="flex items-center space-x-3">
            <div className={`w - 12 h - 12 rounded - lg ${stat.bgColor} flex items - center justify - center`}>
              <Icon name={stat.icon} size={20} className={stat.color} />
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-lg font-bold text-text-primary">
                {stat.total ? `${stat.value} / ${stat.total}` : stat.value}
              </div>
              <div className="text-sm truncate text-text-secondary">
                {stat.label}
              </div>
            </div>
          </div>

          {stat.total && (
            <div className="mt-3">
              <div className="w-full h-2 overflow-hidden rounded-full bg-border">
                <div
                  className={`h-full ${stat.color.replace('text-', 'bg-')} transition-all duration-300 ease-out`}
                  style={{ width: `${(stat.value / stat.total) * 100}%` }}
                />
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default QuickStats;